module.exports = {
    "sku": {
        "front": "<front>",
        "back": "<back>"
    },
    allowSocialShareMain: true,
    "itemid": "<itemid>",

    "programData": {
        field65Label: "Test Listing Type",
        field65Options: "a,b",
    },
    proofEngineType: 0,

    product: {
        // productId: 8 -> Postcards: weight: 3 lbs / 150 pieces
        // other: Newsletter, 6 lbs / 150 pieces
        finishedHeight: 0,
        idProduct: 8,
        name: "Newsletter",
        mailingPieceType: "",
        numberFolds: 0,
    },

    "distributions":[ "mailing", "download", "shipping", "pickup"],
    "distributionLabels": [ "MAIL", "DOWNLOAD", "SHIP", "pickup"],
    "mailingClasses": {
        "3": "Standard",
        "1": "First Class"
    },
    "defaultCoatingType": "high_gloss_coating",
    "defaultCoatingSide": "none", // "none", "side1", "side2", ?"both"?

    "subCategories": {"frontTemplate": {"id": 96433, "name": "Apparel \u0026 Hats"}},
    "categories": {"frontTemplate": {"id": 96432, "name": "Gifts, Promotional and Apparel"}},

    "options":[

        // {
        //     group: "lineItem",
        //     dev_key: "address_lists",
        //     flatPrice: {
        //         1: 2,
        //         2: 0.03,
        //     },
        //     distributionFilter: [],
        // },
        {
            group: "lineItem",
            dev_key: "mailing_permit",
            flatPrice: 3,
            distributionFilter: [],
        },
        {"name": "PDF Download", "dev_key":"pdf_download", "type": "boolean", "default": true, "flatPrice":"2", "distributionFilter": ["mailing", "shipping", "download"]}, // this option for print order with PDF download
        {"group": "PaperTypes", "dev_key":"paper_type", "id": "52", "name": "No Paper", "desc": "No Paper",
            "default":true, "distributionFilter": ["mailing", "shipping", "download", "pickup"],
            "productPrice": {
                "download": {
                    "1.00": {"min":1, "max":999, price: 1.00}
                },
                "shipping": {
                    "0.50" : {"min": 10000, price: 0},
                    "0.55": {"min": 5000, "max":9999, price: 0.55},
                    "0.60": {"min": 1000, "max":4999, price: 0.60},
                    "0.65": {"min": 500, "max":999, price: 0.65},
                    "0.70": {"min": 200, "max":499, price: 0.70},
                    "0.75": {"min": 25, "max":100, price: 0.75}
                },
                "pickup": {
                    "0.50" : {"min": 10000, price: 0.50},
                    "0.55": {"min": 5000, "max":9999, price: 0.55},
                    "0.60": {"min": 1000, "max":4999, price: 0.60},
                    "0.65": {"min": 500, "max":999, price: 0.65},
                    "0.70": {"min": 200, "max":499, price: 0.70},
                    "0.75": {"min": 25, "max":100, price: 0.75}
                },
                "mailing" : {
                    "1":  {
                        "0.50" : {"min": 10000, price: 0.50},
                        "0.55": {"min": 5000, "max":9999, price: 0.55},
                        "0.60": {"min": 1000, "max":4999, price: 0.60},
                        "0.65": {"min": 500, "max":999, price: 0.65},
                        "0.90": {"min": 201, "max":499, price: 0.90},
                        "0.75": {"min": null, "max":100, price: 0.75}
                    },
                    "3":  {
                        "0.50" : {"min": 10000, price: 0.50},
                        "0.55": {"min": 5000, "max":9999, price: 0.55},
                        "0.60": {"min": 1000, "max":4999, price: 0.60},
                        "0.65": {"min": 500, "max":999, price: 0.65},
                        "0.80": {"min": 201, "max":499, price: 0.80},
                        "0.75": {"min": 25, "max":100, price: 0.75}
                    }
                },
            }
        },

        {
            group: "OPTIONS",
            name: "UI Friendly product name",
            devKey: "ui_friendly_product_name",
            value: "Test friendly name",
        },

        {"group": "PaperTypes", "dev_key":"paper_type", "id": "ELECTRONIC", "name": "ELECTRONIC", "desc": "No Paper",
            "default":true, "distributionFilter": ["download"],
            "productPrice": {
                "download": {
                    "0.00": {"min":1, "max":1, price: 0.00}
                },
            }
        },
        {"group": "PaperTypes", "dev_key":"paper_type", "id": "1", "name": "12 pt Paper", "desc": "soft paper", "default":false,
            "distributionFilter": ["mailing", "shipping", "download", "pickup"],
            "productPrice": {
                "download": {
                    "1.00": {"min":1, "max":999}
                },
                "shipping": {
                    "0.55": {"min": 200, "max":6000, price: 0.55},
                    "0.35": {
                        "min": 100, "max":199,
                        price: 0.35,
                        // isFlatRate: true,
                    },
                },
                // "shipping": {
                //     "0.55": {"min": 200, "max":200},
                //     "0.35": {"min": 100, "max":100},
                // },
                "pickup": {
                    "0.50" : {"min": 10000},
                    "0.55": {"min": 5000, "max":9999},
                    "0.60": {"min": 1000, "max":4999},
                    "0.65": {"min": 500, "max":999},
                    "0.70": {"min": 200, "max":499},
                    "0.75": {"min": 25, "max":100}
                },
                "mailing" : {
                    "1":  {
                        "0.60" : {"min": 10000},
                        "0.65": {"min": 5000, "max":9999},
                        "0.70": {"min": 1000, "max":4999},
                        "0.75": {"min": 500, "max":999},
                        "1.10": {"min": 200, "max":499},
                        "0.85": {"min": 25, "max":99}
                    },
                    "3":  {
                        "0.50" : {"min": 10000},
                        "0.55": {"min": 5000, "max":9999},
                        "0.60": {"min": 1000, "max":4999},
                        "0.65": {"min": 500, "max":999},
                        "1.00": {"min": 200, "max":499},
                        "0.75": {"min": 25, "max":100}
                    }
                },
                "default":true, "distributionFilter": ["mailing", "shipping", "pickup"]
                , price: {
                    "download": {
                        "1.00": {"min":1, "max":999}
                    },
                    "shipping": {
                        "0.55": {"min": 201, "max":6000},
                        "0.35": {
                            "min": 100, "max":199,
                            // isFlatRate: true,
                        },
                    },
                    // "shipping": {
                    //     "0.55": {"min": 200, "max":200},
                    //     "0.35": {"min": 100, "max":100},
                    // },
                    "pickup": {
                        "0.50" : {"min": 10000},
                        "0.55": {"min": 5000, "max":9999},
                        "0.60": {"min": 1000, "max":4999},
                        "0.65": {"min": 500, "max":999},
                        "0.70": {"min": 200, "max":499},
                        "0.75": {"min": 25, "max":100}
                    },
                    "mailing" : {
                        "1":  {
                            "0.60" : {"min": 10000},
                            "0.65": {"min": 5000, "max":9999},
                            "0.70": {"min": 1000, "max":4999},
                            "0.75": {"min": 500, "max":999},
                            "1.10": {"min": 201, "max":499},
                            "0.85": {"min": 25, "max":99}
                        },
                        "3":  {
                            "0.50" : {"min": 10000},
                            "0.55": {"min": 5000, "max":9999},
                            "0.60": {"min": 1000, "max":4999},
                            "0.65": {"min": 500, "max":999},
                            "1.00": {"min": 201, "max":499},
                            "0.75": {"min": 25, "max":100}
                        }
                    },
                    "default":true, "distributionFilter": ["mailing", "shipping", "pickup"]
                }},
            "subOptions": [
                {"group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "2", "name": "Back", "desc": "High gloss back","unitPrice": "0.20"},
                {
                    "group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "3", "name": "Both", "desc": "High gloss both",
                    "unitPrice": "0.30",
                },
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "1", "name": "Front","desc": "Soft touch front", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "3", "name": "Both", "desc": "Soft touch both", "unitPrice": "0.20"},
                {"group": "Finishing", "subGroup": "Matte Touch", "dev_key":"matte_touch_coating", "id": "1", "name": "Front", "desc": "Matte touch front", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Matte Touch", "dev_key":"matte_touch_coating", "id": "2", "name": "Back","desc": "Matte touch back", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Matte Touch", "dev_key":"matte_touch_coating", "id": "3", "name": "Both", "desc": "Matte touch both", "unitPrice": "0.20"}
            ]},
        {"group": "PaperTypes", "dev_key":"paper_type", "id": "2", "name": "14 pt Paper", "desc": "medium thickness paper","unitPrice": "0.15", "default":false,
            "distributionFilter": ["mailing", "shipping", "pickup"],
            "productPrice": {
                "download": {
                    "1.00": {"min":1, "max":999, price: 1.00}
                },
                "shipping": {
                    "0.55": {"min": 200, "max":200, price: 0.55},
                    "0.35": {"min": 100, "max":100, price: 0.35},
                },
                "pickup": {
                    "0.50" : {"min": 10000, price: 0.50},
                    "0.55": {"min": 5000, "max":9999, price: 0.55},
                    "0.60": {"min": 1000, "max":4999, price: 0.60},
                    "0.65": {"min": 500, "max":999, price: 0.65},
                    "0.70": {"min": 200, "max":499, price: 0.70},
                    "0.75": {"min": 25, "max":100, price: 0.75}
                },
                "mailing" : {
                    "1":  {
                        "0.50" : {"min": 10000, price: 0.50},
                        "0.55": {"min": 5000, "max":9999, price: 0.55},
                        "0.60": {"min": 1000, "max":4999, price: 0.60},
                        "0.65": {"min": 500, "max":999, price: 0.65},
                        "0.90": {"min": 200, "max":499, price: 0.90},
                        "0.75": {"min": 25, "max":100, price: 0.75}
                    },
                    "3":  {
                        "0.50" : {"min": 10000, price: 0.50},
                        "0.55": {"min": 5000, "max":9999, price: 0.55},
                        "0.60": {"min": 1000, "max":4999, price: 0.60},
                        "0.65": {"min": 500, "max":999, price: 0.65},
                        "1": {"min": 200, "max":499, price: "1"},
                        "0.75": {"min": 25, "max":100, price: 0.75}
                    }
                },
                "default":true, "distributionFilter": ["mailing", "shipping", "pickup"]
            },
            "subOptions": [
                {"group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "1", "name": "Front", "desc": "High gloss front", "unitPrice": "0.10" },
                {"group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "2", "name": "Back", "desc": "High gloss back","unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "3", "name": "Both", "desc": "High gloss both", "unitPrice": "0.20"},
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "1", "name": "Front","desc": "Soft touch front", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "2", "name": "Back", "desc": "Soft touch back", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "3", "name": "Both", "desc": "Soft touch both", "unitPrice": "0.20"},
                {"group": "Finishing", "subGroup": "Matte Touch", "dev_key":"matte_touch_coating", "id": "1", "name": "Front", "desc": "Matte touch front", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Matte Touch", "dev_key":"matte_touch_coating", "id": "2", "name": "Back","desc": "Matte touch back", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Matte Touch", "dev_key":"matte_touch_coating", "id": "3", "name": "Both", "desc": "Matte touch both", "unitPrice": "0.20"}
            ] },
        {"group": "PaperTypes", "dev_key":"paper_type", "id": "3", "name": "16 pt Paper", "desc": "Cardboard thickness paper","unitPrice": "0.00", "default":true,
            "distributionFilter": ["mailing", "shipping", "pickup"],
            "subOptions": [
                {"group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "1", "name": "Front", "desc": "Desc", "unitPrice": "0.10" },
                {"group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "2", "name": "Back", "desc": "Desc","unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "UV Coating", "dev_key":"high_gloss_coating", "id": "3", "name": "Both", "default": true, "desc": "Desc", "unitPrice": "0.20"},
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "1", "name": "Front","desc": "Desc", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "2", "name": "Back", "desc": "Desc", "unitPrice": "0.10"},
                {"group": "Finishing", "subGroup": "Soft Touch", "dev_key":"soft_touch_coating", "id": "3", "name": "Both", "desc": "Desc", "unitPrice": "0.20"}
            ]
        },

        {
            "group": "OPTIONS",
            "name": "Enable Canada Mailing",
            "devKey": "enable_canada_mailing",
            "type": "boolean",
            "isUi": false,
            "isRequired": true,
            "flatPrice": "0.000000",
            "value": "0",
            "distributionFilter": [
                "mailing",
                "shipping",
                "pickup"
            ]
        },

        {
            "group": "DISTRIBUTION",
            "name": "Allow Mailing Lists ",
            "devKey": "is_addressable",
            "type": "boolean",
            "isUi": false,
            "isRequired": true,
            "flatPrice": "0.000000",
            "value": "1",
            "distributionFilter": ["mailing", "shipping", "pickup"]
        },

        {
            "group": "lineItem",
            "name": "Mailing Seals",
            "dev_key": "mailing_seals",
            "description": "Translucent adhesive tabs fastened to the edge of your materials to ensure your mailing remains closed while being mailed.",
            "type": "boolean",
            "isUi": true,
            "isRequired": false,
            "flatPrice": "2.000000",
            "distributionFilter": ["shipping", "mailing"],
            "value": 1
        },


        {
            "group": "lineItem",
            "name": "Envelopes",
            "dev_key": "envelopes",
            "description": "Flat paper container with a sealable flap used to enclose a letter or document",
            "type": "boolean",
            "isUi": true,
            "isRequired": true,
            "flatPrice": "0.120000",
            "distributionFilter": ["shipping"],
            "subOptions": [{
                "name": "6x9 White w\/Window",
                "dev_key": "6X9_WHITE_WINDOW",
                "isUi": true,
                "isRequired": true,
                "flatPrice": "0.000000",
                "distributionFilter": ["shipping"]
            }, {
                "name": "6x9 Red w\/Window",
                "dev_key": "6X9_RED_WINDOW",
                "isUi": true,
                "isRequired": true,
                "flatPrice": "0.000000",
                "distributionFilter": ["shipping"]
            }],
            "value": "1"
        },
        {
            description: "Service to redirect to a webpage via a QR Code scan",
            dev_key: "qr_code",
            distributionFilter: ["mailing"],
            flatPrice: "0.00000",
            group: "lineItem",
            isRequired: false,
            isUi: true,
            name: "QR Code",
            showSubOptions: true,
            subOptions: [
                {
                    dev_key: "xpresslinks",
                    distributionFilter: ["mailing"],
                    flatPrice: "10",
                    isRequired: false,
                    isUi: true,
                    is_active: true,
                    name: "Xpress Links",
                },
                {
                    dev_key: "homevalue",
                    distributionFilter: ["mailing"],
                    flatPrice: "0.200000",
                    isRequired: false,
                    isUi: true,
                    is_active: true,
                    name: "Home Value",
                },
                {
                    dev_key: "url",
                    distributionFilter: ["mailing"],
                    flatPrice: "0.300000",
                    isRequired: false,
                    isUi: true,
                    is_active: true,
                    name: "URL",
                },
            ],
        },
        {
            "devKey": "allow_social_sharing",
            "value": "1"
        },

    ]
};
